import $ from "jquery";
import debug from 'bows/dist/bows.min.js';
import keyboardFocus from "./base/_keyboardFocus";
import smoothScroll from "./base/_smoothScroll";
import share from "./base/_share";
import scrollTriggers from "./modern/_scrollTriggers";
import gtmTracking from './gtm-tracking';

const $window = $(window);
const $document = $(document);
const log = debug("site");



class Site {
	constructor() {
		document.addEventListener('DOMContentLoaded', () => this.ready());
		window.addEventListener('load', () => this.load());
	}
	
	ready() {
		$('html').removeClass('no-js').addClass('js');
		const log = debug("site:domReady");
		console.log('site init modern');
		// tracking.init();


		keyboardFocus.init();
		smoothScroll.init();
		share.init();
        
		gtmTracking.init();
		const All_Details = document.querySelectorAll('details');

		All_Details.forEach(deet=>{
		deet.addEventListener('toggle', toggleOpenOneOnly)
		})

		function toggleOpenOneOnly(e) {
		if (this.open) {
			All_Details.forEach(deet=>{
			if (deet!=this && deet.open) deet.open = false
			});
		}
		}
		$(document).ready(function(){
			scrollTriggers.init();
		
		});
		function jumpElement(hashTag){
			var headerHeight = $('#header-modern').height();
			//var objOffset = $(hashTag).offset().top;
			var elem = document.querySelector(hashTag);
			var objOffset = elem.offsetTop;//getBoundingClientRect().top;
			

			var $offset = 75;
			if ($(window).width()<901){
				$offset = 80;
			}
			console.log('header ' + headerHeight + 'objOffset '+objOffset + ' offset ' +$offset);
			var yOffset =  objOffset - headerHeight - $offset;
			$(window).scrollTop(yOffset);
			document.scrollingElement.scrollTop = yOffset;
			console.log("hash scroll " + yOffset);
			$('.debug-element').html(yOffset + ' ' +hashTag);
		}
		$(window).on('load', function(){

			var hashTag = window.location.hash;
			if (hashTag){
				/*var headerHeight = $('#header-modern').height();
				//var objOffset = $(hashTag).offset().top;
				var elem = document.querySelector(hashTag);
				var objOffset = elem.getBoundingClientRect().top;

				var $offset = 60;
				if ($(window).width()<901){
					$offset = 60;
				}
				var yOffset =  objOffset - headerHeight - $offset;
				$(window).scrollTop(yOffset);
				console.log("init hash scroll " + yOffset);
				$('.debug-element').html(yOffset + ' ' +hashTag);*/
				jumpElement(hashTag);
				/*setTimeout(function(){
					var hashTag = window.location.hash;
					jumpElement(hashTag);
				},700);*/
			}

			let activeJumpURLs = $('ul#mega-menu-modern_global li.mega-current-menu-item a[href*="#"]');
	
			
			$(activeJumpURLs).each(function( index ) {
				let inputString = $(this).attr('href');
				let parts = inputString.split('#');
				let hash = $(this).prop('hash');
				let $where = $(hash);
				// Return the part after the # character
				$(this).attr('href','#'+parts[1]);
				$(this).parent().removeClass('mega-current-menu-item');
				$(this).on('click',function(e){

				var elem = document.querySelector(hash);
				var objOffset = elem.getBoundingClientRect().top;
					if ($('#mega-menu-wrap-modern_global .mega-menu-toggle').hasClass('mega-menu-open')){
						console.log('gogo');
						$('#mega-menu-wrap-modern_global .mega-menu-toggle').trigger( "click" );
					}
					if (elem){
						e.preventDefault();
						/*let topDistance = objOffset;
						let $header = $('#header-modern');
						let $offset = 60;
						if ($(window).width()<901){
							$offset = 100;
						}
						topDistance = parseInt(topDistance) - $header.height() - $offset;
						$(window).scrollTop(topDistance);
						$('.debug-element').html(topDistance + ' ' + hash);
						console.log('vert scroll mega link ' + topDistance);
						//window.history.hash = hash;*/
						jumpElement(hash);
						window.history.pushState(null, null, hash);
					}
				});
			});

			//Adds classes to all FundraiseUp elements
			// Loop through all iframes on the page
			$('main.site-content iframe').each(function() {
				var iframeTitle = $(this).attr('title');
				if (iframeTitle){
					iframeTitle = iframeTitle.toLowerCase();
					iframeTitle = iframeTitle.replace(/\s+/g, '-');
					$(this).addClass(iframeTitle);
					//console.log('Title ' + iframeTitle);
				}
				
			});
			$('.goal-meter').removeAttr('style');
		});

		//Sticky nav

		//shrink nav
		$(function(){

			window.shrunknav = false;
			if ($(window).scrollTop() >= 80) { // if equal to or greater than 100 and hasBeenTrigged is set to false.
				$('#header-modern').addClass('sticky-nav');
				window.shrunknav = true;
			}
			$(window).scroll(function() {
				if ($(this).scrollTop() >= 80) { // if equal to or greater than 100 and hasBeenTrigged is set to false.
					$('#header-modern').addClass('sticky-nav');
					window.shrunknav = true;
				} else if(window.shrunknav) {
				$('#header-modern').removeClass('sticky-nav');
				window.shrunknav = false;
				}
			});
		});

    // log('document.DOMContentLoaded');
	}

	load() {
		const log = debug("site:windowLoad");
		// log("window.onload");

		// example of ES2015 modules loading & tree shaking
		// emptyLinks();
	}

}

export default Site;
window.site = new Site();
